type Badging = {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

function badging(): Badging | null {
  if (typeof navigator === "undefined") return null;
  const it = navigator as Navigator & Badging;
  return typeof it.setAppBadge === "function" ? it : null;
}

export function badgeCountOf(rows: Array<{ unread?: number; muted?: boolean }>): number {
  return rows.filter((row) => (row.unread ?? 0) > 0 && !row.muted).length;
}

export function showBadge(count: number): void {
  const it = badging();
  if (!it) return;
  if (count <= 0) void it.clearAppBadge?.().catch(() => undefined);
  else void it.setAppBadge?.(count).catch(() => undefined);
}
